import { NextRouter } from 'next/router';
import { ParsedUrlQuery } from 'node:querystring';

import { Filters } from '~/features/catalog/models/filter';
import { getCatalogLink } from '~/features/catalog/utils/catalog-url-state-utils';

const FILTER_QUERY_KEYS: (keyof Filters)[] = [
  'scope',
  'price',
  'school',
  'skill',
  'difficulty',
  'duration',
  'rawDuration',
  'type',
  'availability',
  'language',
];

/** Removes every catalog filter (and the page) while keeping the active search and sort. */
export function clearCatalogSearchFilters(router: NextRouter) {
  const updatedQuery: ParsedUrlQuery = { ...router.query };
  delete updatedQuery.page;
  FILTER_QUERY_KEYS.forEach((key) => delete updatedQuery[key]);

  const asPath = getCatalogLink({
    router: {
      ...router,
      query: updatedQuery,
    },
    updatedRouteParameters: {},
  });

  router.replace({ query: updatedQuery }, asPath, {
    shallow: true,
    scroll: false,
  });
}
